
import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { getHomeLayouts, deleteHomeLayout } from "adminApi/HomeLayoutsApi/HomeLayouts";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/HomeLayoutListFields.json";
import { FilterStatus } from "utils/FilterStatus";

const HomeLayoutListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  // Fetch data using shared hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(getHomeLayouts, {
    page,
    limit,
    search: debouncedSearch,
    title: "Home Layout List",
  });

  // Auto-generate display fields
  const displayFields = generateDisplayFields(tabledata);

  // Filter Data (if status filter applied)
  const filteredData = FilterStatus(data);

  // Configure Table Columns & Data
  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Home Layout",
      editUrl: "edit-home-layout",
      idKey: "id",
      deleteApi: deleteHomeLayout,
      displayFields,
    },
  });

  // Handlers
  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default HomeLayoutListTable;
